export class MerchantConfiguration {
	billingNumberPrefix: string
	billingNumberOffset: number
	merchantLogo: { string: string }
	liableToVat: boolean;
	pcuiBaseUrl: string;
	zelosPrint: boolean;
	shipmentByLeomedia: boolean;
	hasMerchantWebsite: boolean;
	paymentServiceName: string;
}

export const PaymentServiceNameEnum = {
	PAYMILL: "Paymill",
	WIRECARD: "Wirecard",
	MOCKED: "dummy-mock",

}



// WEBPACK FOOTER //
// ./src/app/models/merchant-configuration.model.ts